import { IconButton, Stack } from "@mui/material";
import { ClearIcon } from "@mui/x-date-pickers";
import { isNil, sortBy } from "lodash";
import { useEffect, useMemo } from "react";
import Select, { type SingleValue } from "react-select";
import { useCompanyContactsLazyQuery } from "../../generated/graphql";

const ContactSelect = ({
  companyUuid,
  currentContactUuid,
  setContactUuid,
  noLabel,
  minWidth,
}: {
  readonly companyUuid: string | null | undefined;
  readonly currentContactUuid: string | null | undefined;
  readonly setContactUuid: (uuid: string | null) => void;
  readonly noLabel?: boolean;
  readonly minWidth?: number;
}) => {
  const [getCompanyContacts, { data: contactsData }] =
    useCompanyContactsLazyQuery();

  useEffect(() => {
    if (!isNil(companyUuid)) {
      getCompanyContacts({
        variables: {
          companyUuid,
        },
      });
    }
  }, [companyUuid, getCompanyContacts]);

  const contactOptions = useMemo(() => {
    if (isNil(companyUuid)) {
      return [];
    }
    return sortBy(
      contactsData?.companyContacts,
      (contact) => contact.displayName,
    ).map((contact) => ({
      value: contact.uuid,
      label: `${contact.displayName}${contact.isActive ? "" : " (archived)"}`,
    }));
  }, [companyUuid, contactsData?.companyContacts]);

  const currentOption = contactOptions?.find(
    (option) => option.value === currentContactUuid,
  );

  return (
    <div style={{ fontWeight: "normal" }}>
      {noLabel !== true && <div>Select contact</div>}
      <Stack direction="row" spacing={0.5} sx={{ minWidth }}>
        <Select
          menuPosition="fixed"
          options={contactOptions}
          placeholder="Select contact"
          value={currentOption ?? null}
          onChange={(option: SingleValue<{ label: string; value: string }>) => {
            if (!isNil(option) && !isNil(option.value)) {
              setContactUuid(option.value);
            }
          }}
        />
        {!isNil(currentContactUuid) && (
          <IconButton
            size="small"
            onClick={() => {
              setContactUuid(null);
            }}
          >
            <ClearIcon />
          </IconButton>
        )}
      </Stack>
    </div>
  );
};

export default ContactSelect;
